<template>
    <div class="enter-delivery-address-button" @click="onClick">
        <div class="delivery-address-icon-left">
            <i class="fa-light fa-location-dot fa-xl"></i>
        </div>

        <div v-if="isNoDeliveryAddressProvided" class="no-delivery-address-container">
            <div class="text-enter-delivery-address">{{ translations.deliveryAddress.enterDeliveryAddress }}</div>
        </div>
        <div v-else class="delivery-address-container">
            <div v-if="street.length !== 0" class="contact-email">{{ street }}</div>
            <div v-if="addressDetails.length !== 0" class="contact-email">{{ addressDetails }}</div>
            <div v-if="postalCodeAndCity.length !== 0" class="contact-phone-number">{{ postalCodeAndCity }}</div>
            <!--            <div v-if="country != null" class="contact-phone-number">{{ country }}</div>-->
        </div>

        <div class="delivery-address-icon-right">
            <i class="fal fa-arrow-right fa-xl"></i>
        </div>
    </div>
    <div class="line" style="height: 1px; width: 100%; background-color: #f5f5f5"></div>
</template>

<script setup lang="ts">
    import { EnterDeliveryAddressContentPopover } from "@/app/popover/EnterDeliveryAddressContentPopover";
    import { Popup } from "@/components/dialog/Popup";
    import { Country } from "@/data/model/Enums";
    import type { IContactData } from "@/data/model/Profile";
    import { useCartStore } from "@/data/stores/cart";
    import { translations as trans, translations } from "@/shared/localization/translations";
    import { computed } from "vue";

    import EnterDeliveryAddressForm from "@/components/pay/EnterDeliveryAddressForm.vue";

    const cart = useCartStore();

    const props = defineProps<{
        isInOperatorApp: boolean;
        onUpdateDeliveryAddress?: () => void;
    }>();

    const isNoDeliveryAddressProvided = computed(() => {
        return cart.currentCart?.deliveryAddress == null;
    });


    const street = computed<string>(() => {
        return `${cart.currentCart?.deliveryAddress?.street ?? ""}`.trim();
    });

    const addressDetails = computed<string>(() => {
        return `${cart.currentCart?.deliveryAddress?.addressDetails ?? ""}`.trim();
    });

    const postalCodeAndCity = computed<string>(() => {
        return `${cart.currentCart?.deliveryAddress?.postalCode ?? ""} ${cart.currentCart?.deliveryAddress?.city ?? ""}`.trim();
    });

    const country = computed<string | undefined>(() => {
        return cart.currentCart?.deliveryAddress != null
            ? translations.enums.Country[Country[cart.currentCart.deliveryAddress.country]]
            : undefined;
    });

    function onClick() {
        if (props.isInOperatorApp) {
            let popup = Popup.show({
                component: EnterDeliveryAddressForm,
                componentProps: {
                    isInOperatorApp: props.isInOperatorApp,
                    hide: () => {
                        popup?.close();
                    },
                },
                showConfirmButton: false,
                closePopupOnOverlayClick: true,
                showCloseButton: true,
                title: trans.deliveryAddress.enterDeliveryAddress,
            });
        } else {
            const popover = new EnterDeliveryAddressContentPopover(false);
            popover.show();
        }
    }

    function getContactData(): IContactData | undefined {
        return cart.currentCart?.contactDataEndUser;
    }

    defineExpose({
        getContactData,
    });
</script>

<style scoped lang="scss">
    @use "../../../../assets/styles/scss/shared/colors";

    .enter-delivery-address-button {
        display: flex;
        padding: 10px 24px;
        justify-content: space-between;
        min-height: 40px;
        align-items: center;

        .delivery-address-icon-left {
            color: colors.$lightFontColor;
        }

        > .no-delivery-address-container {
            > .text-enter-delivery-address {
                color: colors.$red;
                margin: 0 24px;
                font-weight: 600;
                width: 100%;
            }
        }

        > .delivery-address-container {
            width: 100%;
            margin: 0 24px;

            .contact-full-name {
                font-size: 12px;
                font-weight: 700;
            }

            .contact-email {
                font-size: 12px;
            }

            .contact-phone-number {
                font-size: 12px;
            }

            .complete-contact-data-btn {
                font-size: 12px;
                font-weight: 700;
            }

            .text-complete-contact-data {
                color: colors.$pink;
                font-weight: 700;
                font-size: 12px;
                width: 100%;
            }
        }

        .delivery-address-icon-right {
            color: colors.$lightFontColor;
        }
    }
</style>
